import { LegalDocumentPage } from "@/components/legal/LegalDocumentPage";
import { legalDocuments } from "@/content/legalDocuments";

export default function Accessibility() {
  return <LegalDocumentPage document={legalDocuments.accessibility} />;
}